const twilioConfig = {
	accountSid: "ACc099db91b199c62a26de7362654d4a99",
	authToken: "89b58b8e17a0ed3d36044998633d1f39",
	phoneNumber: "+16602855175",
};

export default twilioConfig;
